import { CHANGE_LOCALE } from '../locale';
export function changeLocale(data) {
    return { type: CHANGE_LOCALE, data: data };
}



// WEBPACK FOOTER //
// ./src/actions/creators/locale.js